

import { Colors, FlexBox } from '@brg/ui';
import styled, { css } from 'styled-components';

export const PageControl = styled.div<{ disabled?: boolean }>`
    height: 32px;
    cursor: pointer;
    user-select: none;

    svg path {
        fill: ${Colors.geoWhite47};
    }
    ${(p) =>
        p.disabled
            ? css`
                  svg path {
                      fill: ${Colors.geoWhite47} !important;
                  }
              `
            : null};
`;

export const PageNumber = styled(FlexBox)<{ active?: boolean; disabled?: boolean }>`
    justify-content: center;
    align-items: center;
    min-width: 32px;
    height: 32px;
    border-radius: 3px;
    color: ${Colors.geoWhite47};
    cursor: pointer;
    user-select: none;
    font-size: 13px;
    line-height: 16px;
    &:hover {
        color: ${Colors.geoWhite73};
    }
    ${(p) =>
        p.active
            ? css`
                  color: ${(p) => p.theme.inputs.pagination.color} !important;
                  background: ${(p) => p.theme.inputs.pagination.backgroundColor};
              `
            : null};

    ${(p) =>
        p.disabled
            ? css`
                  curson: initial !important;
              `
            : null};
`;


import { Colors, FlexBox } from '@brg/ui';
import styled, { css } from 'styled-components';

export const PageControl = styled.div<{ disabled?: boolean }>`
    height: 32px;
    cursor: pointer;
    user-select: none;

    svg path {
        fill: ${Colors.geoWhite47};
    }
    ${(p) =>
        p.disabled
            ? css`
                  svg path {
                      fill: ${Colors.geoWhite47} !important;
                  }
              `
            : null};
`;

export const PageNumber = styled(FlexBox)<{ active?: boolean; disabled?: boolean }>`
    justify-content: center;
    align-items: center;
    min-width: 32px;
    height: 32px;
    border-radius: 3px;
    color: ${Colors.geoWhite47};
    cursor: pointer;
    user-select: none;
    font-size: 13px;
    line-height: 16px;
    &:hover {
        color: ${Colors.geoWhite73};
    }
    ${(p) =>
        p.active
            ? css`
                  color: ${(p) => p.theme.inputs.pagination.color} !important;
                  background: ${(p) => p.theme.inputs.pagination.backgroundColor};
              `
            : null};

    ${(p) =>
        p.disabled
            ? css`
                  curson: initial !important;
              `
            : null};
`;
